<template>
  <section-page
    title="Billing Portal"
    is-short
  >
    <p class="subscription_message mb-100" v-if="isOnGracePeriod">
      <strong>Account Is Canceled</strong> <br>
      You're currently in your grace period of Forefront
      until the end of this billing period. During this time you will have access to Forefront and may
      <a @click="openBillingPortal">resume your subscription</a> if you wish to continue using Forefront.
    </p>

    <button-outlined
      size=""
      @click="openBillingPortal"
    >Visit Billing Portal
    </button-outlined>
  </section-page>
</template>

<script>
import {ENUMS} from "../../../services/enums";

export default {
  name: "AccountPaymentMethod",
  computed: {
    account() {
      return this.$store.getters.account;
    },
    isOnGracePeriod() {
      return this.account.status === ENUMS.AccountStatusEnum.GracePeriod.value;
    },
  },
};
</script>

<style lang="scss" scoped>

.subscription_message {
  line-height: 1.3;
}
</style>
